import { Component, OnInit } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { BugReportService } from "../shared/services/bug-report/bug-report.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FeatureFlagsService } from "../agilx/shared/feature-flags.service";

@Component({
  selector: "app-header-component",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  isLogin: boolean;
  username: string;
  usernameSubscription: Subscription;

  constructor(
    private router: Router,
    private authService: authenticationService,
    private bugReportService: BugReportService,
    private spinner: NgxSpinnerService,
    private featureFlagsService: FeatureFlagsService
  ) {
    this.username = this.authService.getUsername();
  }

  ngOnInit() {
    const loginUrls = ["/login", "/reset"];
    if (loginUrls.some((url) => this.router.url.startsWith(url))) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.isLogin = loginUrls.some((url) => event.url.startsWith(url));
      });

    this.usernameSubscription = this.authService.getUsernameObservable().subscribe((username) => {
      this.username = username;
    });
  }

  ngOnDestroy() {
    if (this.usernameSubscription) {
      this.usernameSubscription.unsubscribe();
    }
  }

  hasPermission(permissionName: string) {
    const permission = Permissions[permissionName];
    return this.authService.hasPermission(permission);
  }

  isFeatureEnabled(featureName: string): boolean {
    return this.featureFlagsService.isEnabled(featureName as any);
  }

  sliderFunctionality() {
    document.getElementById("menuRol").className = "dropdown";
  }

  logout() {
    this.authService.logout();
  }

  async reportBug() {
    const description = prompt("Please describe the issue you encountered (optional):");

    this.spinner.show();

    try {
      await this.bugReportService.sendBugReport(description || undefined);
    } catch (error) {
      console.error("Failed to send bug report:", error);
      alert("Failed to send bug report. Please try again or contact support directly.");
    } finally {
      this.spinner.hide();
    }
  }
}
